import React, { useEffect, useState } from "react";
import {
  useQuery,
  useSelectedTheme,
  useTranslate,
} from "../../../../../../../../Hooks";
import {
  CustomButton,
  CustomCard,
  CustomDialog,
  DropzoneComponent,
} from "../../../../../../../../Components";
import { Box, Divider, Typography } from "@material-ui/core";
import { getDownloadableLink } from "../../../../../../../../Helper";
import { useVerticalNav } from "../../../../../../../../Contexts/VerticalNavContext";
import { UpdatePropertyVideo } from "../../../../../../../../Services";

// styles
import useStyles from "./styles";

// icons
import {
  DeleteIcon,
  Download01,
  VideoCreatorIcon,
} from "../../../../../../../../assets/icons";

function EditPropertyVideoDialog({
  open,
  onClose,
  data,
  activeVideo,
  setRefetchDataPropertyVideo,
}) {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { setAlertBoxContent } = useVerticalNav();
  const query = useQuery();
  const [filesAccepted, setFilesAccepted] = useState([]);
  const [uploadedFileId, setUploadedFileId] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [initalizeTotalVideo, setInitalizeTotalVideo] = useState(0);
  const [selectedVideo, setSelectedVideo] = useState(0);

  const handleFilesAccepted = (files) => {
    setFilesAccepted(files);
  };

  const handleDeleteUploadedFile = (index) => {
    setUploadedFiles((prevUploadedFiles) =>
      prevUploadedFiles.filter((_, i) => i !== index)
    );
    setInitalizeTotalVideo(initalizeTotalVideo - 1);
  };

  const handleFileUploadMapping = () => {
    if (uploadedFileId) {
      setUploadedFiles((prevUploadedFiles) => [
        ...prevUploadedFiles,
        filesAccepted[0],
      ]);
      setUploadedFiles((prevUploadedFiles) => {
        const updatedFiles = [...prevUploadedFiles];
        if (updatedFiles?.length > 0) {
          updatedFiles[updatedFiles.length - 1] = {
            ...updatedFiles[updatedFiles.length - 1],
            categoryId: data.categoryId,
            fileId: uploadedFileId,
            fileName: updatedFiles[updatedFiles?.length - 1]?.path,
            propertyId: Number(query.get("id")),
          };
        }
        return updatedFiles;
      });
      setInitalizeTotalVideo(initalizeTotalVideo + 1);
    }
  };

  const handleSave = async () => {
    try {
      const mappedFiles = uploadedFiles.map((file) => ({
        fileId: file.fileId,
        fileName: file.fileName,
      }));

      const body = {
        categoryId: data.categoryId,
        propertyId: Number(query.get("id")),
        files: mappedFiles,
      };
      const res = await UpdatePropertyVideo(body);
      if (!(res && res.status && res.status !== 200)) {
        setAlertBoxContent({
          display: true,
          variant: "success",
          title: translate("update-Video-Property-successfully"),
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
        setRefetchDataPropertyVideo(true);
        onClose();
      } else {
        setAlertBoxContent({
          display: true,
          variant: "error",
          title: translate("Updated-Video-Failed"),
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
      }
    } catch (error) {
      console.error(error, "Something went wrong");
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("Something-went-wrong"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    } finally {
    }
  };

  const downloadDocument = (item) => {
    if (!item) {
      return;
    }
    try {
      const link = document.createElement("a");
      link.setAttribute("download", item.fileName);
      link.href = getDownloadableLink(item.fileId);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  useEffect(() => {
    const files = Array.isArray(data?.videos) ? data.videos : [];
    const initialActive = activeVideo || files[0];
    const reordered = initialActive
      ? [
          initialActive,
          ...files.filter((img) => img.fileId !== initialActive.fileId),
        ]
      : files;
    setUploadedFiles(reordered);
    setInitalizeTotalVideo(files.length);
    setSelectedVideo(initialActive);
  }, [data]);

  useEffect(() => {
    handleFileUploadMapping();
  }, [uploadedFileId]);

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      title={translate("Edit-video-group")}
      subtitle={translate(
        "Create-and-schedule-new-activity-to-enhance-engagement-with-your-contacts-and-leads"
      )}
      cancelText={translate("Cancel")}
      confirmText={translate("Save-changes")}
      onConfirm={handleSave}
      width={"699px"}
      content={
        <Box className={styles.wrapperEditDialog}>
          <Typography className={styles.titleItem}>
            {translate("video")}
          </Typography>
          <Box className={styles.containerUploadSection}>
            <DropzoneComponent
              accept="video/*"
              title={translate("SVG-PNG-JPG-or-GIF-max-800x400px")}
              onFilesAccepted={handleFilesAccepted}
              setUploadedFileId={setUploadedFileId}
            />
            <Box className={styles.secctionImage}>
              <Box className={styles.containerImageTitle}>
                <Typography className={styles.ImageTitle}>
                  {`${initalizeTotalVideo} videos`}
                </Typography>
                <Divider style={{ flexGrow: 1, alignSelf: "center" }} />
              </Box>
              <Box className={styles.containerUploadedFiles}>
                {uploadedFiles.map((file, index) => (
                  <CustomCard
                    key={file.fileId || index}
                    boxShadow="xs"
                    borderRadius="xl"
                    borderColor="secondary"
                    classes={styles.cardUploadedFilesInfo}
                    onClick={() => setSelectedVideo(file)}
                    style={{
                      border:
                        selectedVideo?.fileId === file.fileId
                          ? `2px solid ${palette.button.primary_bg}`
                          : "2px solid transparent",
                      cursor: "pointer",
                    }}
                  >
                    <Box className={styles.containerImage}>
                      <video
                        className={styles.videoPreview}
                        height="100%"
                        width="100%"
                      >
                        <source
                          src={getDownloadableLink(file.fileId)}
                          type="video/mp4"
                        />
                        <source
                          src={getDownloadableLink(file.fileId)}
                          type="video/webm"
                        />
                        <source
                          src={getDownloadableLink(file.fileId)}
                          type="video/ogg"
                        />
                      </video>
                    </Box>

                    <Box
                      onClick={() => handleDeleteUploadedFile(index)}
                      className={styles.containerDeleteIcon}
                    >
                      <DeleteIcon
                        width="20"
                        height="20"
                        fill={palette.foreground.secondary_fg}
                      />
                    </Box>

                    <Box className={styles.containerPlaceHolderImage}>
                      <VideoCreatorIcon
                        width="56"
                        height="56"
                        fill={palette.foreground.senary}
                      />
                    </Box>
                  </CustomCard>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      }
      moreAction={
        <CustomButton
          boxShadow="none"
          size="lg"
          variant="text"
          color="tertiaryGray"
          startIcon={
            <Download01
              width="20"
              height="20"
              fill={palette.button.tertiaryGray_fg}
            />
          }
          onClick={() => {
            downloadDocument(selectedVideo);
          }}
          style={{ marginInlineEnd: "auto" }}
        >
          {translate("Download")}
        </CustomButton>
      }
    />
  );
}

export default EditPropertyVideoDialog;
